import { LayoutGrid, List } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Small Card / List toggle button group.
 * Pair with `useViewMode` for localStorage persistence.
 */
export default function ViewToggle({ mode, onChange, testid = "view-toggle" }) {
  return (
    <div className="inline-flex border border-border" data-testid={testid}>
      <Button
        type="button"
        size="sm"
        variant={mode === "card" ? "default" : "ghost"}
        className="rounded-none h-8 px-2"
        onClick={() => onChange("card")}
        data-testid={`${testid}-card`}
        title="Card view"
      >
        <LayoutGrid className="w-3.5 h-3.5" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant={mode === "list" ? "default" : "ghost"}
        className="rounded-none h-8 px-2"
        onClick={() => onChange("list")}
        data-testid={`${testid}-list`}
        title="List view"
      >
        <List className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
}
